// extracted by mini-css-extract-plugin
export default {"title":"RatingsAndReviewsSource_title__Tpr2f","wrapper":"RatingsAndReviewsSource_wrapper__gkmkY"};